import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { PROLEAD } from "@/constants/testIds";
import { toast } from "sonner";
import { CheckCircle2 } from "lucide-react";

export default function Professional() {
  const { t } = useTranslation();
  const [f, setF] = useState({ name: "", venue: "", country: "", email: "", phone: "", website: "", business_type: "", goals: "" });
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.post("/professional-leads", f); setOk(true); toast.success(t("pro.toast_success")); }
    catch { toast.error(t("pro.toast_fail")); }
    finally { setLoading(false); }
  };
  const bullets = t("pro.bullets", { returnObjects: true });
  return (
    <div className="text-white">
      <section className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-12">
        <div>
          <span className="preshh-badge-pro mb-4">{t("pro.kicker")}</span>
          <h1 className="font-display text-5xl md:text-6xl leading-tight mt-4">{t("pro.headline")}</h1>
          <p className="mt-3 font-display text-2xl md:text-3xl text-white/80 leading-tight">{t("pro.title")}</p>
          <p className="mt-6 text-white/70 leading-relaxed text-lg">
            {t("pro.subtitle")}
          </p>
          <p className="mt-4 text-white/60 text-sm italic">
            {t("pro.notice")}
          </p>
          <ul className="mt-8 space-y-3 text-white/80">
            {(Array.isArray(bullets) ? bullets : []).map((x, i) => (
              <li key={i} className="flex gap-2"><CheckCircle2 size={18} className="text-[#C9A96E] mt-0.5 shrink-0" /> {x}</li>
            ))}
          </ul>
        </div>
        <form data-testid={PROLEAD.form} onSubmit={submit} className="bg-[#111] border border-white/10 rounded-3xl p-6 md:p-8 space-y-4">
          {ok ? (
            <div className="py-12 text-center">
              <CheckCircle2 size={44} className="text-[#C9A96E] mx-auto" />
              <p className="mt-4 font-display text-2xl">{t("pro.thank_you")}</p>
              <p className="mt-2 text-white/60">{t("pro.consultant_soon")}</p>
            </div>
          ) : (
            <>
              <h2 className="font-display text-2xl">{t("pro.form_title")}</h2>
              <p className="text-sm text-white/60 -mt-2">{t("pro.form_intro")}</p>
              <Input data-testid={PROLEAD.name} placeholder={t("pro.f_name")} value={f.name} onChange={upd("name")} required className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.venue} placeholder={t("pro.f_venue")} value={f.venue} onChange={upd("venue")} required className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.country} placeholder={t("pro.f_country")} value={f.country} onChange={upd("country")} required className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.email} type="email" placeholder={t("pro.f_email")} value={f.email} onChange={upd("email")} required className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.phone} placeholder={t("pro.f_phone")} value={f.phone} onChange={upd("phone")} className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.website} placeholder={t("pro.f_website")} value={f.website} onChange={upd("website")} className="bg-white/5 border-white/10" />
              <Input data-testid={PROLEAD.bizType} placeholder={t("pro.f_biz")} value={f.business_type} onChange={upd("business_type")} className="bg-white/5 border-white/10" />
              <Textarea data-testid={PROLEAD.goals} placeholder={t("pro.f_goals")} value={f.goals} onChange={upd("goals")} className="bg-white/5 border-white/10 min-h-24" />
              <Button data-testid={PROLEAD.submit} type="submit" disabled={loading} className="w-full bg-[#C9A96E] hover:bg-[#B79256] text-black font-bold rounded-full py-6">
                {loading ? t("pro.sending") : t("pro.cta")}
              </Button>
            </>
          )}
        </form>
      </section>
    </div>
  );
}
